export default {
  'base.notFound.title': '抱歉，页面未找到',
  'base.notFound.desc': '您访问的页面不存在或已被移除',
  'base.notFound.home': '返回首页',
}
